import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PageNavigationService {
  private platformId = inject(PLATFORM_ID);

  constructor(private routeService: Router) { }

  scrollTo(id: string, altRoute?: any[], rootEl?: HTMLElement) {
    if (!isPlatformBrowser(this.platformId)) return;
    const el = rootEl
      ? rootEl.querySelector<HTMLElement>('#' + id)
      : document.getElementById(id);
    if (!el && altRoute) {
      this.routeService.navigate(altRoute).then(() => {
        // Find a better way to wait for the page to fully load
        setTimeout(() => { this.scrollTo(id, undefined, rootEl); }, 400);
      });
    } else if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
